import { Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { MainLayoutComponent } from '../../../_layouts/main-layout/main-layout.component';
import { TypeheadComponent } from '../../../../Shared/_components/typehead/typehead.component';
import { ProductService } from '../../../_services/product.service';
import { AlertService } from '../../../_services/alert.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule, NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, NgModel } from '@angular/forms';
import { ConfirmDialogComponent } from '../../../../Shared/_components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterLink } from '@angular/router';
import { CartService } from '../../../_services/cart.service';
import { CartComponent } from './partials/cart/cart.component';
import { UserService } from '../../../_services/users.service';
import { userRoles } from '../../../../Shared/_constants/constants';
import { CustomerTypeheadComponent } from './partials/customer-typehead/customer-typehead.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { BillingFormComponent } from './partials/billing-form/billing-form.component';
import { AddEditCustomerComponent } from '../../customers/add-edit-customer/add-edit-customer.component';
import { SuggestedCoupon } from '../../../_services/coupon.service';
import { CouponService } from '../../../_services/coupon.service';
import { postcodes } from './../../../../Shared/_constants/constants';
import { getStoneCladdingHandlingFee, isFullCrateFormat, getStoneCladdingLoads, isPavingProduct, isStoneCladdingProduct, stoneCladdingCartons } from '../delivery-rules';
import { OrderService, RecommendationResult } from '../../../_services/order.service';
import { SiteSettingsService } from '../../../_services/site-settings.service';
import { CreateAddressModalComponent } from './partials/create-address-modal/create-address-modal.component';
import { KlarnaModalComponent } from './partials/klarna-modal/klarna-modal.component';
import { environment } from '../../../../../environments/environment';
import { TncComponent } from "../../../../Shared/_components/tnc/tnc.component";
import { firstValueFrom, forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CartLeadState } from '../abandoned-carts/abandoned-carts.component';
import { GiveAwayProductSelectionComponent } from './partials/give-away-product-selection/give-away-product-selection.component';
import { PaypalButtonComponent } from '../../../../Shared/_components/paypal-button/paypal-button.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-create-sale',
    imports: [
        MainLayoutComponent,
        TypeheadComponent,
        MatProgressBarModule,
        NgClass,
        MatButtonModule,
        FormsModule,
        CartComponent,
        CustomerTypeheadComponent,
        MatExpansionModule,
        BillingFormComponent,
        CommonModule,
        KlarnaModalComponent,
        RouterLink,
        TncComponent,
        PaypalButtonComponent,
        MatIconModule,
        MatTooltipModule,
    ],
    templateUrl: './create-sale.component.html',
    styleUrl: './create-sale.component.css'
})
export class CreateSaleComponent implements OnInit {
  productSuggestionList: { id: number; name: string; slug?: string, sku: string }[] = [];
  progress: boolean = false;
  areaCoverage: number = 0;
  slabsCrates: any;
  editingProduct: any;
  localCart: any = {
    items: [],
    total: 0,
    totalFormatted: '',
  };
  frontEndURL = environment.frontEndURL;
  currentStep = 1;
  customers:any;
  defaultBillingAddress:any;
  defaultShippingAddress: any;
  billingAddresses:any = [];
  shippingAddresses:any = [];
  selectedCustomer:any;
  selectedDeliveryMethod: string = 'STANDARD';
  deliveryType = '';
  selectedPaymentOption = 'INVOICE';
  // Payment methods switched on for the back office in Site Settings (all until loaded).
  enabledPaymentMethods = new Set(['TEYA', 'PAYPAL', 'BANK_TRANSFER', 'INVOICE']);

  paymentOn(method: string): boolean {
    return this.enabledPaymentMethods.has(method);
  }

  // If the selected method is switched off, move to the first one that's on.
  private ensurePaymentMethodAvailable(): void {
    if (this.paymentOn(this.selectedPaymentOption)) return;
    const next = ['INVOICE', 'TEYA', 'PAYPAL', 'BANK_TRANSFER'].find((m) => this.paymentOn(m));
    if (next) this.onPaymentMethodSelection(next);
  }
  paypalResponse: any;
  paypalPaymentComplete: boolean = false;
  paypalPaymentError: string = '';
  sameAddress = true;
  enteredCouponCode:string = '';
  appliedCouponCodes: any[] = [];
  redeemedDicounts: any[] = [];
  couponError: any;
  loyaltyRedemptionError: any;
  loyaltyRedeemed = 0;
  loyaltyPoint: number = 0;
  loyaltyRedeemAmount: number = 0;
  customerInfo: any;
  customerMode: string = 'CUSTOMER';
  subTotal = 0;
  netTotal = 0;
  vatAmount = 0;
  shipCost = 0;
  handleCharge = 0;
  invalidPostcode = true;
  postCode = '';
  priceOnRequest: boolean = false;
  klarnaSnippet: string = '';
  userVatNu: string = '';
  zoneNumber: string = '';
  readonly dialog = inject(MatDialog);
  readonly panelOpenState = signal(false);
  @ViewChild('vatInput') vatInput!: NgModel;
  orderNotes = '';
  tncAccepted = false;
  orderSubmitted:boolean = false;
  
  constructor(
    private productService: ProductService,
    private alertService: AlertService,
    private router: Router,
    private cartService: CartService,
    private userService: UserService,
    private couponService: CouponService,
    private orderService: OrderService,
    private siteSettingsService: SiteSettingsService,
  ) {}

  // Set when this sale was started from an abandoned web cart (Sales page):
  // who the shopper is and what changed in their basket since they left it.
  cartLead: CartLeadState['cartLead'] | null = null;
  prefillCustomer: any = null;

  ngOnInit(): void {
    this.siteSettingsService.get().subscribe((settings) => {
      this.enabledDeliveryMethods = new Set(
        this.deliveryMethods.map((m) => m.value).filter((v) => this.siteSettingsService.isDeliveryEnabledInBackOffice(settings, v)),
      );
      this.ensureDeliveryMethodAvailable();
      this.enabledPaymentMethods = new Set(
        ['TEYA', 'PAYPAL', 'BANK_TRANSFER', 'INVOICE'].filter((m) => this.siteSettingsService.isPaymentEnabledInBackOffice(settings, m)),
      );
      this.ensurePaymentMethodAvailable();
    });
    this.getAllProducts();
    this.cartService.cart$.subscribe((cartData: any) => {
      this.localCart = cartData;
    });
    const lead = (history.state as Partial<CartLeadState> | null)?.cartLead;
    if (lead) {
      this.cartLead = lead;
      if (lead.account?.userid) {
        this.prefillCustomer = lead.account;
        this.onCustomerSelection(lead.account);
      }
    }
    // Started from a product in the Sales page's "Pitch this hour": open it in the picker.
    const pitch = (history.state as { pitchProductSlug?: string } | null)?.pitchProductSlug;
    if (pitch) this.openAccessory(pitch);
    this.refreshRecommendations();
    this.refreshCouponSuggestions();
  }

  onProductSelection(selectedProd: {
    id: number;
    name: string;
    slug?: string;
  }) {
    this.progress = true;
    if (selectedProd.id) this.loadProductInfo(selectedProd.id); // in parallel with the product
    if (selectedProd.slug) {
      this.getSelectedProduct(selectedProd.slug);
    }
  }

  onCustomerSelection(selectedCustomer: any) {
    if (selectedCustomer && selectedCustomer.userid) {
      this.selectedCustomer = selectedCustomer;
      this.userVatNu = this.selectedCustomer.vatnumber;
      this.progress = true;
      this.resetAddresses();
      this.getCustomerAddresses(selectedCustomer.userid);
      this.refreshRecommendations();
      this.refreshCouponSuggestions();
    }else {
      this.selectedCustomer = undefined;
      this.resetAddresses();
      this.refreshRecommendations();
    }
  }

  // Matches the storefront's cartService.verifyPavingProduct().
  private isPavingProduct(categorySlug: string, sku: string): boolean {
    return isPavingProduct(categorySlug, sku);
  }

  // Some accessories (e.g. paving/fencing/decking adhesives) carry a
  // "With X"/"Without X" format option - "With X" only makes sense if the
  // matching product is actually in the basket already. Mirrors the same
  // guard on the storefront's product page so staff can't build an order
  // the live site itself wouldn't allow.
  private checkAccessoryDependencies(format: string): string | null {
    if (!format) return null;
    if (format.indexOf('With Paving') >= 0) {
      const pavingFound = (this.localCart.items ?? []).some((item: any) => this.isPavingProduct(item.categorySlug, item.sku));
      if (!pavingFound) return "No Paving products found in the basket, please change to 'Without Paving' option!";
    }
    if (format.indexOf('With Fencing') >= 0) {
      const fencingFound = (this.localCart.items ?? []).some((item: any) => item.categorySlug?.indexOf('fencing') >= 0 && item.name?.indexOf('Panel Kit') >= 0);
      if (!fencingFound) return "No Fencing products found in the basket, please change to 'Without Fencing' option!";
    }
    if (format.indexOf('With Decking') >= 0) {
      const deckingFound = (this.localCart.items ?? []).some((item: any) => item.categorySlug?.indexOf('decking') >= 0 && item.name?.indexOf('3D Embossed') >= 0);
      if (!deckingFound) return "No Decking products found in the basket, please change to 'Without Decking' option!";
    }
    if (format.indexOf('With Panels') >= 0) {
      if ((this.localCart.total ?? 0) <= 88) return "Order amount should be >= 88 for selecting 'With Panels' option, please change to 'Without Panels' option!";
    }
    return null;
  }

  onAddToCart(cartItem: any) {
    let productsForCart = [];
    if(cartItem.quantity <=0 )
    {
      this.alertService.alert("Invalid quantity!!", 'error');
      return;
    }
    if(cartItem.mStockQty < cartItem.quantity && cartItem.kStockQty < cartItem.quantity)
    {
      this.alertService.alert("Stock quantity is not sufficient!!", 'error');
      return;
    }

    const accessoryError = this.checkAccessoryDependencies(cartItem.format);
    if (accessoryError) {
      this.alertService.alert(accessoryError, 'error');
      return;
    }

    switch (this.editingProduct.product.productTemplateId) {
      case 1:
        let productName = cartItem.format
          ? this.editingProduct.product.productName + '-' + cartItem.format
          : this.editingProduct.product.productName;
        let itemObj = {
          name: productName,
          sku: cartItem.sku,
          productId: cartItem.productId,
          variantId: cartItem.productVariantId,
          unitPrice:
          cartItem.discPrice > 0
              ? cartItem.discPrice
              : cartItem.price,
          quantity: cartItem.quantity,
          onSale: cartItem.discPrice > 0 ? true : false,
          categorySlug:
          this.editingProduct.product.productcategories[0].category
              .categoryParentId == 0
              ? this.editingProduct.product.productcategories[0].category.categorySlug
              : this.editingProduct.product.productcategories[0].category
                  .categoryParentIds.categorySlug,
          categoryId: this.editingProduct.product.productcategories[0].category.categoryId,
          parentId:  this.editingProduct.product.productcategories[0].category
              .categoryParentId == 0
              ? this.editingProduct.product.productcategories[0].category.categoryId
              : this.editingProduct.product.productcategories[0].category
                  .categoryParentIds.categoryId,
          isFullCrate: isFullCrateFormat(cartItem.format),
          weight: cartItem.weight,
          deliveryTermSlug: cartItem.deliveryterm?.deliveryTermSlug,
          productFormat: cartItem.format
        };
        productsForCart.push(itemObj);
        break;
      case 2:
        let itemObjCrate = {
          name: this.editingProduct.product.productName + '- ' + cartItem.slabType,
          sku: cartItem.sku,
          productId: cartItem.productId,
          variantId: cartItem.productVariantId,
          unitPrice:
            cartItem.discPrice > 0
              ? cartItem.discPrice
              : cartItem.price,
          quantity: cartItem.quantity,
          onSale: cartItem.discPrice > 0 ? true : false,
          categorySlug:
            this.editingProduct.product.productcategories[0].category
              .categoryParentId == 0
              ? this.editingProduct.product.productcategories[0].category
                  .categorySlug
              : this.editingProduct.product.productcategories[0].category
                  .categoryParentIds.categorySlug,
          categoryId: this.editingProduct.product.productcategories[0].category.categoryId,
          parentId:  this.editingProduct.product.productcategories[0].category
              .categoryParentId == 0
              ? this.editingProduct.product.productcategories[0].category.categoryId
              : this.editingProduct.product.productcategories[0].category
                  .categoryParentIds.categoryId,
          isFullCrate: cartItem.slabType == 'CRATE',
          weight: cartItem.weight,
          deliveryTermSlug: cartItem.deliveryterm?.deliveryTermSlug,
          productFormat: cartItem.slabType
        };
        productsForCart.push(itemObjCrate);
        break;
    }

    productsForCart.forEach(
      (item: {
        quantity: number;
        unitPrice: number;
        sku: string;
        productId: number;
        variantId: number;
        name: string;
        onSale: boolean;
        categorySlug: string;
        isFullCrate: boolean;
        weight: number;
        deliveryTermSlug: string;
        productFormat: string;
      }) => {
        const isExists = this.localCart.items?.find(
          (cItem: any) => cItem.sku === item.sku && cItem.unitPrice === item.unitPrice
        );
        if (isExists) {
          if(cartItem.mStockQty < item.quantity + isExists.quantity && cartItem.kStockQty < item.quantity + isExists.quantity)
          {
            this.alertService.alert("Quantity requested is geater than available stock!", 'error');
            return;
          }
          isExists.quantity += item.quantity;
        } else {
          this.localCart.items.push(item);
        }
        this.localCart.total += item.unitPrice * item.quantity;
        this.localCart.totalFormatted = this.localCart.total.toFixed(2);
      }
    );
    this.localCart.appliedCouponCodes = [];
    this.removeGiveAwayItms();
    this.cartService.setCart(this.localCart);
    this.appliedCouponCodes = [];
    this.calculateShippingCost();
  }

  onVatNumberChanged(){}

  onAddressSelection(addrs: any) {
    this.postCode = '';
    if (addrs.addressType === 'BILLING') this.defaultBillingAddress = addrs;
    if (addrs.addressType === 'SHIPPING') this.defaultShippingAddress = addrs;
    if (this.defaultShippingAddress && !this.sameAddress) {
      this.postCode = this.defaultShippingAddress?.postCode;
    } else {
      this.postCode = this.defaultBillingAddress?.postCode;
    }
    this.calculateShippingCost();
  }

  onClose() {
    let modelConfig: any = {
      data: {
        title: "Cancel this sale?",
        message: "Everything entered so far will be thrown away.",
        detail: this.localCart?.items?.length
          ? `${this.localCart.items.length} item${this.localCart.items.length === 1 ? '' : 's'} in the basket (£${(Number(this.localCart.total) || 0).toFixed(2)}) will be removed.`
          : undefined,
        tone: 'danger',
        icon: 'remove_shopping_cart',
        confirmText: 'Yes, cancel the sale',
        cancelText: 'No, keep editing',
      },
    };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, modelConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if(result.confirmation) {
        this.router.navigate(['/sales']);
      }
    });
  }

  onResetAll() {
    let modelConfig: any = {
      data: {
        title: "Start again?",
        message: "This clears the basket, the customer and everything else in this sale.",
        tone: 'warning',
        icon: 'restart_alt',
        confirmText: 'Yes, clear it all',
        cancelText: 'No, keep it',
      },
    };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, modelConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if(result.confirmation) {
        this.onReset();
      }
    });
  }

  onReset(){
    this.editingProduct = undefined;
    this.selectedCustomer = null;
    this.userVatNu = "";
    this.localCart = {
      items: [],
      total: 0,
      totalFormatted: '',
    };

    this.enteredCouponCode = '';
    this.couponError = undefined;
    this.loyaltyRedemptionError = undefined;
    this.loyaltyRedeemed = 0;
    this.loyaltyPoint = this.customerInfo ?  this.customerInfo?.userpoints: 0;
    this.loyaltyRedeemAmount = 0;
    this.subTotal = 0;
    this.netTotal = 0;
    this.redeemedDicounts = [];
    this.appliedCouponCodes = [];
    this.customerMode = 'CUSTOMER';
    this.selectedDeliveryMethod = 'STANDARD';
    this.ensureDeliveryMethodAvailable();
    this.selectedPaymentOption = 'INVOICE';
    this.ensurePaymentMethodAvailable();
    this.paypalResponse = undefined;
    this.paypalPaymentComplete = false;
    this.paypalPaymentError = '';
    this.currentStep = 1;
    this.recommendations = null;
    this.recommendationKey = '';
    this.refreshRecommendations();
    this.couponSuggestionKey = '';
    this.refreshCouponSuggestions();
  }

  onBack() {
    if (this.currentStep !== 1) this.currentStep -= 1;
  }

  // ---- Discount codes an agent can offer ----
  couponSuggestions: SuggestedCoupon[] = [];
  private couponSuggestionKey = '';

  // Refetched when the basket, its totals or the customer change.
  private couponTimer: any;
  refreshCouponSuggestions() {
    // A basket change triggers several recalculations in a row; wait for them to settle.
    clearTimeout(this.couponTimer);
    this.couponTimer = setTimeout(() => this.loadCouponSuggestions(), 250);
  }

  private loadCouponSuggestions() {
    const items = (this.localCart?.items ?? []).map((i: any) => ({
      productId: i.productId, categoryId: i.categoryId, parentId: i.parentId, categorySlug: i.categorySlug,
      quantity: i.quantity, unitPrice: i.unitPrice, onSale: !!i.onSale,
    }));
    const customerId = this.customerMode === 'CUSTOMER' ? Number(this.selectedCustomer?.userid) || 0 : 0;
    const userType = this.customerInfo?.usertype || 'NONMEMBER';
    const cartTotal = Number(this.localCart?.total) || 0;
    const netTotal = Number(this.netTotal) || 0;
    const key = JSON.stringify([items, Math.round(cartTotal), Math.round(netTotal), customerId, userType]);
    if (key === this.couponSuggestionKey) return;
    this.couponSuggestionKey = key;
    this.couponService.getSuggestedCoupons({ items, cartTotal, netTotal, customerId, userType }).subscribe({
      next: (list) => {
        if (key === this.couponSuggestionKey) this.couponSuggestions = list ?? [];
      },
      error: () => {
        if (key === this.couponSuggestionKey) this.couponSuggestions = []; // non-fatal
      },
    });
  }

  // Discounts cost margin, so they're only pushed where they help: a code
  // that lifts the order (needs a bit more spend) is the one to lead with;
  // codes that already apply are held back for closing a hesitant customer.
  // Codes that don't fit the basket, or an empty basket, show nothing.
  get couponBoosters(): SuggestedCoupon[] {
    return this.couponSuggestions.filter((c) => c.status === 'needsSpend').sort((a, b) => a.shortfall - b.shortfall).slice(0, 4);
  }

  get couponReserve(): SuggestedCoupon[] {
    return this.couponSuggestions.filter((c) => c.status === 'applies');
  }

  get hasCouponAdvice(): boolean {
    return this.couponBoosters.length > 0 || this.couponReserve.length > 0;
  }

  // What the code costs, as a share of the order.
  couponCostPercent(c: SuggestedCoupon): number {
    const total = Number(this.localCart?.total) || 0;
    return total > 0 ? (c.saving / total) * 100 : 0;
  }

  // How far the basket is towards the code's minimum spend, 0-100.
  couponProgress(c: SuggestedCoupon): number {
    if (!c.minSpend) return 100;
    return Math.max(0, Math.min(100, ((c.minSpend - c.shortfall) / c.minSpend) * 100));
  }

  // A line the agent can say to the customer.
  couponPitch(c: SuggestedCoupon): string {
    const off = c.percent ? `${c.value}%` : `£${c.value}`;
    return `Add £${c.shortfall.toFixed(2)} more to your order and I can take ${off} off with code ${c.code}.`;
  }

  isCouponApplied(code: string): boolean {
    return this.appliedCouponCodes.some((c: any) => String(c.couponCode).toLowerCase() === String(code).toLowerCase());
  }

  applySuggestedCoupon(c: SuggestedCoupon) {
    this.enteredCouponCode = c.code;
    this.onApplyCouponCode();
  }

  // ---- Suggestions from past orders ----
  recommendations: RecommendationResult | null = null;
  recommendationsLoading = false;
  private recommendationKey = '';

  // Refetches only when the products in play or the customer changed.
  private recommendationTimer: any;
  refreshRecommendations() {
    // The page's own data (products, customers) goes first; suggestions can follow.
    clearTimeout(this.recommendationTimer);
    this.recommendationTimer = setTimeout(() => this.loadRecommendations(), 300);
  }

  private loadRecommendations() {
    const ids = new Set<number>((this.localCart?.items ?? []).map((i: any) => Number(i.productId)).filter(Boolean));
    const current = Number(this.editingProduct?.product?.productId);
    if (current) ids.add(current);
    const customerId = this.customerMode === 'CUSTOMER' ? Number(this.selectedCustomer?.userid) || 0 : 0;
    const productIds = [...ids].sort((a, b) => a - b);
    const key = `${productIds.join(',')}|${customerId}`;
    if (key === this.recommendationKey) return;
    this.recommendationKey = key;
    this.recommendationsLoading = true;
    // Even with nothing chosen yet there's something to show: trending,
    // seasonal and offers.
    this.orderService.getRecommendations({ productIds, customerId }).subscribe({
      next: (r) => {
        if (key !== this.recommendationKey) return;
        this.recommendations = r;
        this.recommendationsLoading = false;
      },
      error: () => {
        // Non-fatal: suggestions just don't show.
        if (key !== this.recommendationKey) return;
        this.recommendations = null;
        this.recommendationsLoading = false;
      },
    });
  }

  // Six cards fit one row when the page has the full width; next to the basket
  // the column is narrower, so they fall into two neat rows of three.
  get laneGridClass(): string {
    return this.localCart?.items?.length > 0
      ? 'grid-cols-2 sm:grid-cols-3 min-[1900px]:grid-cols-6'
      : 'grid-cols-2 sm:grid-cols-3 xl:grid-cols-6';
  }

  readonly laneTone: Record<string, { icon: string; note: string }> = {
    amber: { icon: 'bg-amber-50 text-amber-500', note: 'text-amber-700' },
    violet: { icon: 'bg-violet-50 text-violet-500', note: 'text-violet-700' },
    orange: { icon: 'bg-orange-50 text-orange-500', note: 'text-orange-700' },
    sky: { icon: 'bg-sky-50 text-sky-500', note: 'text-sky-700' },
    emerald: { icon: 'bg-emerald-50 text-emerald-500', note: 'text-emerald-700' },
    rose: { icon: 'bg-rose-50 text-rose-500', note: 'text-rose-700' },
    indigo: { icon: 'bg-indigo-50 text-indigo-500', note: 'text-indigo-700' },
  };

  // Looks a suggested product up in the picker (step 1); from step 2 it goes back there first.
  openSuggestion(slug: string) {
    if (this.currentStep !== 1) this.currentStep = 1;
    this.openAccessory(slug);
  }

  // ---- Key information from the product page (step 1) ----
  // Pulled from the same content blocks the website shows: highlights, what
  // is in each kit, the "good to know" notes and the recommended accessories.
  productInfo: ProductInfo | null = null;
  productAccessories: { slug: string; name: string; image: string | null; from: number; inStock: boolean }[] = [];
  infoTab: 'highlights' | 'kit' | 'notes' | 'accessories' = 'highlights';

  get infoTabs(): { key: 'highlights' | 'kit' | 'notes' | 'accessories'; label: string; icon: string; count: number }[] {
    const i = this.productInfo;
    if (!i) return [];
    return [
      { key: 'highlights' as const, label: 'Highlights', icon: 'verified', count: i.highlights.length },
      { key: 'kit' as const, label: "What's in the kit", icon: 'view_module', count: i.kits.length },
      { key: 'notes' as const, label: 'Good to know', icon: 'lightbulb', count: i.notes.length },
      { key: 'accessories' as const, label: 'Accessories', icon: 'construction', count: this.productAccessories.length },
    ].filter((t) => t.count > 0);
  }

  // The delivery estimates across this product's options, without repeats.
  get deliveryPromises(): string[] {
    const seen = new Set<string>();
    for (const v of this.editingProduct?.variants ?? []) {
      const d = v?.deliveryterm?.deliveryTermDesc;
      if (d) seen.add(String(d).trim());
    }
    return [...seen];
  }

  get freeSampleSlug(): string | null {
    return this.editingProduct?.product?.freeSample?.productSlug ?? null;
  }

  get productRating(): number {
    return Number(this.editingProduct?.product?.rating) || 0;
  }

  private infoProductId = 0; // the product the info panel is being loaded for

  private loadProductInfo(productId: number) {
    this.infoProductId = productId;
    this.productInfo = null;
    this.productAccessories = [];
    this.productService.getProductDetails(productId).subscribe({
      next: (rows) => {
        if (this.infoProductId !== productId) return; // moved on to another product
        this.productInfo = this.parseProductDetails(rows ?? []);
        this.infoTab = this.infoTabs[0]?.key ?? 'highlights';
        this.loadAccessories(this.productInfo.accessorySlugs, productId);
      },
      error: () => (this.productInfo = null), // non-fatal: the card just doesn't show
    });
  }

  private loadAccessories(slugs: string[], productId: number) {
    if (!slugs.length) return;
    this.productService.getProductCards(slugs.slice(0, 6)).subscribe({
      next: (cards) => {
        if (this.infoProductId !== productId) return;
        this.productAccessories = (cards ?? []).map((c) => ({ slug: c.slug, name: c.name, image: c.image, from: c.from, inStock: c.inStock }));
        if (!this.infoTabs.some((t) => t.key === this.infoTab)) this.infoTab = this.infoTabs[0]?.key ?? 'highlights';
      },
      error: () => {}, // non-fatal
    });
  }

  // Loads an accessory into the picker, like choosing it from the search.
  openAccessory(slug: string) {
    this.progress = true;
    this.getSelectedProduct(slug);
  }

  private parseProductDetails(rows: any[]): ProductInfo {
    const info: ProductInfo = { highlights: [], kits: [], notes: [], accessorySlugs: [], layingGuide: null };
    if (typeof DOMParser === 'undefined') return info;
    const dom = (html: string) => new DOMParser().parseFromString(html, 'text/html');
    const plain = (html: string) => (dom(html.replace(/<br\s*\/?>/gi, '\n')).body.textContent ?? '').replace(/\u00a0/g, ' ');
    let accessoriesNext = false;

    for (const row of [...rows].sort((a, b) => a.rowId - b.rowId)) {
      let columns: any[] = [];
      try { columns = JSON.parse(row.rowData); } catch { continue; }
      for (const comp of columns.flatMap((c: any) => c?.components ?? [])) {
        if (comp.type === 'vc_column_text' && comp.html) {
          const html: string = comp.html;
          if (/<table/i.test(html)) {
            const doc = dom(html);
            const trs = Array.from(doc.querySelectorAll('tr')).map((tr) =>
              Array.from(tr.querySelectorAll('th,td')).map((c) => (c.textContent ?? '').replace(/\u00a0/g, ' ').trim()),
            ).filter((r) => r.length);
            const title = (doc.querySelector('h1,h2,h3,h4')?.textContent ?? '').trim();
            if (trs.length) info.kits.push({ title, headers: trs[0], rows: trs.slice(1) });
            const guide = doc.querySelector('a[href$=".pdf"], a[href*=".pdf"]') as HTMLAnchorElement | null;
            if (guide && !info.layingGuide) info.layingGuide = { text: (guide.textContent ?? 'Laying guide').trim(), href: guide.href };
          } else if (!info.highlights.length) {
            const checks = plain(html).split('\n').map((l) => l.trim()).filter((l) => /^[\u2705\u2714\u2713\u2611]/.test(l));
            if (checks.length) info.highlights = checks.map((l) => l.replace(/^[\u2705\u2714\u2713\u2611\uFE0F\s]+/, ''));
          }
          if (/accessories/i.test(plain(html)) && plain(html).length < 400) accessoriesNext = true;
        } else if (comp.type === 'vc_toggle' && comp.html) {
          info.notes.push({ title: comp.title || 'Good to know', html: comp.html });
        } else if (comp.type === 'product_links' && accessoriesNext) {
          for (const link of comp.links ?? []) {
            const m = String(link).match(/\/product\/([^\/?#]+)/);
            if (m) info.accessorySlugs.push(m[1]);
          }
          accessoriesNext = false;
        }
      }
    }
    return info;
  }

  // ---- Coverage calculator (step 1) ----
  // "I need 20 m²": works out which formats to buy from what is in stock.
  calcArea: number | null = null;
  calcWastage = 10; // % added for cuts and breakage
  readonly wastageOptions = [0, 5, 10];
  coverageSuggestions: CoverageSuggestion[] = [];
  coverageMessage = '';

  get hasCoverageVariants(): boolean {
    return (this.editingProduct?.variants ?? []).some((v: any) => Number(v.approxCoverage) > 0);
  }

  // What can actually be sold: the add-to-cart check allows up to the larger
  // of the two yards' stock for a single line.
  private availableQty(v: any): number {
    return Math.max(Number(v?.mStockQty) || 0, Number(v?.kStockQty) || 0);
  }

  get coverageTarget(): number {
    return (Number(this.calcArea) || 0) * (1 + this.calcWastage / 100);
  }

  onCoverageInputChange() {
    this.recalcCoverage();
  }

  setWastage(pct: number) {
    this.calcWastage = pct;
    this.recalcCoverage();
  }

  clearCoverage() {
    this.calcArea = null;
    this.coverageSuggestions = [];
    this.coverageMessage = '';
  }

  recalcCoverage() {
    this.coverageSuggestions = [];
    this.coverageMessage = '';
    const area = Number(this.calcArea) || 0;
    if (area <= 0) return;
    if (area > 1000) {
      this.coverageMessage = 'That is a very large area - please enter 1,000 m² or less, or split it into several orders.';
      return;
    }
    const target = this.coverageTarget;
    const variants = (this.editingProduct?.variants ?? []).filter((v: any) => Number(v.approxCoverage) > 0);
    const items = variants
      .map((v: any) => ({ v, avail: this.availableQty(v), units: Math.round(Number(v.approxCoverage) * 100), price: Math.round(this.effectivePrice(v) * 100) }))
      .filter((i: any) => i.avail > 0 && i.units > 0);
    if (!items.length) {
      this.coverageMessage = 'None of the formats that cover an area are in stock right now.';
      return;
    }

    const totalUnits = items.reduce((sum: number, i: any) => sum + i.units * i.avail, 0);
    const targetUnits = Math.ceil(target * 100 - 1e-6);
    if (totalUnits < targetUnits) {
      const all = items.map((i: any) => ({ variant: i.v, qty: i.avail }));
      this.coverageSuggestions = [this.buildSuggestion('ALL', 'Everything in stock', 'inventory_2', all, area, target)];
      this.coverageMessage = `Not enough stock to cover ${target.toFixed(2)} m². All the stock left covers ${(totalUnits / 100).toFixed(2)} m².`;
      return;
    }

    const modes: { key: CoverageSuggestion['key']; label: string; icon: string }[] = [
      { key: 'VALUE', label: 'Best value', icon: 'savings' },
      { key: 'EXCESS', label: 'Least left over', icon: 'straighten' },
      { key: 'PACKS', label: 'Fewest packs', icon: 'inventory' },
    ];
    const seen = new Set<string>();
    for (const m of modes) {
      const picked = this.solveCoverage(targetUnits, items, m.key as 'VALUE' | 'EXCESS' | 'PACKS');
      if (!picked) continue;
      const sig = picked.map((p) => `${p.variant.productVariantId}:${p.qty}`).sort().join('|');
      if (seen.has(sig)) continue; // same answer as an earlier one
      seen.add(sig);
      this.coverageSuggestions.push(this.buildSuggestion(m.key, m.label, m.icon, picked, area, target));
    }
  }

  // Bounded knapsack over coverage in hundredths of a m²: the cheapest (or
  // tightest, or fewest-pack) way to reach at least `targetUnits`.
  private solveCoverage(
    targetUnits: number,
    items: { v: any; avail: number; units: number; price: number }[],
    mode: 'VALUE' | 'EXCESS' | 'PACKS',
  ): { variant: any; qty: number }[] | null {
    const maxPack = Math.max(...items.map((i) => i.units));
    const size = targetUnits + maxPack + 1;
    const chunks: { item: number; count: number; units: number; cost: number }[] = [];
    items.forEach((it, idx) => {
      // More than enough packs of one kind to pass the target is never useful.
      let left = Math.min(it.avail, Math.ceil((targetUnits + maxPack) / it.units));
      for (let take = 1; left > 0; take *= 2) {
        const n = Math.min(take, left);
        const cost = mode === 'PACKS' ? n * 1_000_000 + n * it.price : n * it.price;
        chunks.push({ item: idx, count: n, units: n * it.units, cost });
        left -= n;
      }
    });

    const dp = new Float64Array(size).fill(Infinity);
    dp[0] = 0;
    const took = chunks.map(() => new Uint8Array(size));
    chunks.forEach((ch, layer) => {
      for (let c = size - 1; c >= ch.units; c--) {
        const prev = dp[c - ch.units];
        if (prev !== Infinity && prev + ch.cost < dp[c]) {
          dp[c] = prev + ch.cost;
          took[layer][c] = 1;
        }
      }
    });

    let best = -1;
    for (let c = targetUnits; c < size; c++) {
      if (dp[c] === Infinity) continue;
      if (mode === 'EXCESS') { best = c; break; }           // the smallest total that still covers
      if (best === -1 || dp[c] < dp[best]) best = c;        // cheapest / fewest; ties keep the smaller total
    }
    if (best === -1) return null;

    const qty = new Array(items.length).fill(0);
    let c = best;
    for (let layer = chunks.length - 1; layer >= 0; layer--) {
      if (took[layer][c]) {
        qty[chunks[layer].item] += chunks[layer].count;
        c -= chunks[layer].units;
      }
    }
    return items.map((it, i) => ({ variant: it.v, qty: qty[i] })).filter((l) => l.qty > 0);
  }

  private buildSuggestion(
    key: CoverageSuggestion['key'],
    label: string,
    icon: string,
    lines: { variant: any; qty: number }[],
    area: number,
    target: number,
  ): CoverageSuggestion {
    const coverage = lines.reduce((sum, l) => sum + l.qty * Number(l.variant.approxCoverage), 0);
    const price = lines.reduce((sum, l) => sum + l.qty * this.effectivePrice(l.variant), 0);
    const packs = lines.reduce((sum, l) => sum + l.qty, 0);
    return {
      key, label, icon, lines, coverage, price, packs,
      extra: Math.max(0, coverage - area),
      perM2: coverage > 0 ? price / coverage : 0,
      short: coverage + 1e-9 < target,
    };
  }

  // Puts the suggested quantities on the option cards; optionally adds them.
  applyCoverage(s: CoverageSuggestion, addToBasket: boolean) {
    for (const v of this.editingProduct?.variants ?? []) v.quantity = 0;
    for (const l of s.lines) l.variant.quantity = l.qty;
    if (!addToBasket) return;
    for (const l of s.lines) this.onAddToCart(l.variant);
    for (const v of this.editingProduct?.variants ?? []) v.quantity = 0; // don't add the same lines twice
  }

  // ---- Product info shown to the agent (step 1) ----
  galleryImage: string | null = null;

  get productImages(): string[] {
    const seen = new Set<string>();
    for (const v of this.editingProduct?.variants ?? []) {
      for (const img of v.images ?? []) if (typeof img === 'string') seen.add(img);
    }
    return [...seen].slice(0, 8);
  }

  get mainImage(): string | null {
    return this.galleryImage ?? this.productImages[0] ?? null;
  }

  get productLabels(): string[] {
    return (this.editingProduct?.product?.productLabels ?? [])
      .map((l: any) => l?.labels?.label || l?.labels?.title)
      .filter(Boolean);
  }

  // Primary category first, then the rest; a handful is plenty.
  get productCategoryNames(): string[] {
    const cats = [...(this.editingProduct?.categories ?? [])].sort((a: any, b: any) => Number(!!b.isPrimary) - Number(!!a.isPrimary));
    return cats.map((c: any) => c?.category?.categoryName).filter(Boolean).slice(0, 4);
  }

  // Coverage and pieces-per-pack attributes ("Crate coverage", "Patio kit
  // coverage", "Tiles per patio kit"...) are shown per option in the cards
  // below, so they're left out of this list.
  private isPerOptionSpec(name: string): boolean {
    return /coverage|\b(tiles|slabs|pieces|units)\s+per\b/i.test(name);
  }

  // The non-variant attributes: material, colour, finish and so on.
  get productSpecs(): { name: string; value: string }[] {
    const out: { name: string; value: string }[] = [];
    for (const a of this.editingProduct?.attributes ?? []) {
      if (a.variants || a.visible === false) continue;
      const name = a.productattribute?.attributeName;
      if (name && this.isPerOptionSpec(String(name))) continue;
      const value = (a.attributevalues ?? [])
        .map((v: any) => v?.productattributeName?.attributeValue)
        .filter(Boolean)
        .join(', ');
      if (name && value && !out.some((o) => o.name === name && o.value === value)) out.push({ name, value });
    }
    return out;
  }

  effectivePrice(v: any): number {
    return Number(v?.discPrice) > 0 ? Number(v.discPrice) : Number(v?.price) || 0;
  }

  pricePerM2(v: any): number {
    const coverage = Number(v?.approxCoverage) || 0;
    if (coverage > 0) return this.effectivePrice(v) / coverage;
    return Number(v?.priceMS) || 0;
  }

  weightPerM2(v: any): number {
    const coverage = Number(v?.approxCoverage) || 0;
    return coverage > 0 ? (Number(v?.weight) || 0) / coverage : 0;
  }

  savingPercent(v: any): number {
    const price = Number(v?.price) || 0;
    return price > 0 ? Math.round(((price - this.effectivePrice(v)) / price) * 100) : 0;
  }

  dimensionsOf(v: any): string {
    const parts = [v?.length, v?.width, v?.height].map((n) => Number(n) || 0);
    return parts.some((n) => n > 0) ? parts.map((n) => (n > 0 ? n : '-')).join(' × ') : '';
  }

  get fromPrice(): number {
    const prices = (this.editingProduct?.variants ?? []).map((v: any) => this.effectivePrice(v)).filter((n: number) => n > 0);
    return prices.length ? Math.min(...prices) : 0;
  }

  get fromPricePerM2(): number {
    const per = (this.editingProduct?.variants ?? []).map((v: any) => this.pricePerM2(v)).filter((n: number) => n > 0);
    return per.length ? Math.min(...per) : 0;
  }

  get inStockOptions(): number {
    return (this.editingProduct?.variants ?? []).filter((v: any) => Number(v.stockQty) > 0).length;
  }

  async copyText(text: string | null | undefined, label: string) {
    try {
      await navigator.clipboard.writeText(String(text ?? ''));
      this.alertService.alert(`${label} copied`, 'success');
    } catch {
      this.alertService.alert('Could not copy - your browser blocked it', 'error');
    }
  }

  // ---- Delivery method choices (step 3) ----
  readonly deliveryMethods = [
    { value: 'STANDARD', label: 'Standard', icon: 'local_shipping', hint: 'Usual delivery times' },
    { value: 'EXPRESS', label: 'Express', icon: 'bolt', hint: 'Faster delivery' },
    { value: 'NEXTDAY', label: 'Next day', icon: 'event_available', hint: 'Delivered the next day' },
    { value: 'COLLECTION', label: 'Collection', icon: 'storefront', hint: 'Customer collects from the yard' },
  ];

  // ---- Steps ----
  readonly steps = [
    { id: 1, label: 'Products', icon: 'inventory_2' },
    { id: 2, label: 'Customer', icon: 'person' },
    { id: 3, label: 'Delivery & payment', icon: 'payments' },
  ];

  // Only backwards: moving forward goes through Confirm & Next, which checks
  // that the step is complete.
  goToStep(id: number) {
    if (id < this.currentStep && !this.orderSubmitted) this.currentStep = id;
  }

  // The one-line "what's been chosen" under each step's name.
  stepSummary(id: number): string {
    switch (id) {
      case 1: {
        const count = this.localCart?.items?.length ?? 0;
        return count ? `${count} item${count === 1 ? '' : 's'}` : 'Choose products';
      }
      case 2: {
        const a = this.defaultBillingAddress;
        if (a?.firstName || a?.lastName) return `${a.firstName ?? ''} ${a.lastName ?? ''}`.trim();
        return this.customerMode === 'GUEST' ? 'Guest details' : 'Who is buying';
      }
      default:
        return this.currentStep === 3 ? String(this.selectedPaymentOption ?? '').replace(/_/g, ' ').toLowerCase() : 'Choose how to pay';
    }
  }

  onQuantityChange() {
    const coverageBySlabs = this.slabsCrates.slab.quantity * this.slabsCrates.slab.approxCoverage;
    const coverageByCrates = this.slabsCrates.crate.quantity * this.slabsCrates.crate.approxCoverage;
    this.areaCoverage = coverageByCrates + coverageBySlabs;
  }

  onAreaChange() {
    const numberOfSlabsNeed = this.areaCoverage / this.slabsCrates.slab.approxCoverage;
    if (numberOfSlabsNeed < this.slabsCrates.slab.approxCoverage) {
      this.slabsCrates.slab.quantity = Math.round(numberOfSlabsNeed);
    } else {
      let numberOfCratesRequired = numberOfSlabsNeed / this.slabsCrates.crate.approxTiles;
      numberOfCratesRequired = Math.trunc(numberOfCratesRequired);
      this.slabsCrates.crate.quantity = numberOfCratesRequired;
      const slabs = numberOfSlabsNeed - this.slabsCrates.crate.quantity * this.slabsCrates.crate.approxTiles;
      this.slabsCrates.slab.quantity = Math.round(slabs);
    }
  }

  onConfirmAndNext() {
    switch(this.currentStep) {
       case 1: 
         this.currentStep = 2;
         break;
       case 2:
        if (this.customerMode == 'CUSTOMER' && !this.selectedCustomer){
          this.alertService.alert("Select a customer or change to guest mode!!","error");
          break;
         }
        if (this.defaultBillingAddress == null){
          this.alertService.alert("Billing address is required","error");
          break;
        }
        if (this.invalidPostcode){
          this.alertService.alert("Invalid Postcode!!","error");
          break;
         }
         if (this.vatInput.invalid) {
          this.alertService.alert("Invalid vat number!!","error");
          break;
         }
         this.currentStep = 3;
         break;
       case 3:
         this.saveOrder();
         break;
    }
  }

  onBillingFormSubmit(event:any) {
    this.defaultBillingAddress = event.billingAddress;
    this.defaultBillingAddress.email = this.defaultBillingAddress.email.toLowerCase();
    //this.defaultBillingAddress.addressType = 'BILLING';
    this.defaultShippingAddress = event?.sameShippingAddress ? null : event.shippingAddress;
    if (this.defaultShippingAddress) {
      this.defaultShippingAddress.email = this.defaultShippingAddress.email.toLowerCase();
       //this.defaultBillingAddress.addressType = 'SHIPPING';
    }
    this.postCode = event?.sameShippingAddress ? event.billingAddress.postCode : event.shippingAddress.postCode ;
    this.sameAddress =  event?.sameShippingAddress;
    this.calculateShippingCost();
  }

  onCreateCustomer() {
    let modelConfig: any = {
      width: '75%',
      minHeight: '500px',
    };
    const dialogRef = this.dialog.open(AddEditCustomerComponent, modelConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status) {
        if(result.customer) { 
          this.selectedCustomer = result.customer; 
          this.userVatNu = this.selectedCustomer.vatnumber;
        }
      }
    });
  }

  // Delivery options switched on for the back office in Site Settings
  // (null until loaded - everything shows meanwhile).
  private enabledDeliveryMethods: Set<string> | null = null;

  get availableDeliveryMethods() {
    const enabled = this.enabledDeliveryMethods;
    return enabled ? this.deliveryMethods.filter((m) => enabled.has(m.value)) : this.deliveryMethods;
  }

  // If the chosen option has been switched off, move to the first one left.
  private ensureDeliveryMethodAvailable(): void {
    const options = this.availableDeliveryMethods;
    if (options.length && !options.some((m) => m.value === this.selectedDeliveryMethod)) {
      this.onDeleveryMethodSelection(options[0].value);
    }
  }

  onDeleveryMethodSelection(delMethod: string) {
    this.selectedDeliveryMethod = delMethod;
    if ((this.selectedDeliveryMethod === 'EXPRESS' || this.selectedDeliveryMethod === 'NEXTDAY') && this.paymentOn('INVOICE')) {
      this.onPaymentMethodSelection('INVOICE');
    }
    this.calculateShippingCost();
  }

  onPaymentMethodSelection(payMethod: string) {
    this.selectedPaymentOption = payMethod;
    if (payMethod !== 'PAYPAL') {
      this.paypalPaymentComplete = false;
      this.paypalResponse = undefined;
      this.paypalPaymentError = '';
    }
  }

  onPaypalWalletClicked() {
    this.onConfirmAndNext();
  }

  onPaypalResponseRecieved(paypalResponse: any) {
    this.paypalPaymentError = '';
    if (paypalResponse && paypalResponse.status) {
      this.paypalResponse = paypalResponse;
      this.paypalPaymentComplete = true;
      this.saveOrder();
    } else {
      switch (paypalResponse.errorType) {
        case 'CUSTOMER_CANCELLED':
          this.paypalPaymentError = "Please complete the payment or select different payment method";
          break;
        case 'SOMETHING_WENT_WRONG':
          this.paypalPaymentError = "Something went wrong while capturing your payment. Please try again.";
          break;
        default:
          this.paypalPaymentError = '';
      }
    }
  }

  onCustomerModeSelection(mode: string) {
    this.customerMode = mode;
    this.selectedCustomer = null;
    this.customerInfo = null;
    this.refreshRecommendations();
    this.refreshCouponSuggestions();
  } 

  onLoyaltyRedemption() {
    if (this.loyaltyRedeemAmount < 50) {
      this.loyaltyRedemptionError = 'Minimum loyality points usage is 50';
    } else if (this.localCart.total < 500) {
      this.loyaltyRedemptionError =
        'To use loyality points you must exceed cart sub total of £' + this.customerInfo?.minOrderValue;
    } else if (this.loyaltyRedeemAmount > 500) {
      this.loyaltyRedemptionError =
        'Please select loyality points less than 500 to redeem';
    } else if (this.loyaltyRedeemAmount > this.loyaltyPoint) {
      this.loyaltyRedemptionError =
        'Please select loyality points less than available points';
    } else {
      this.loyaltyPoint -= this.loyaltyRedeemAmount;
      this.loyaltyRedeemed = this.loyaltyRedeemAmount;
      this.loyaltyRedemptionError = undefined;
      this.calculateSubTotal();
    }
  }

  onLoyaltyPointsRemoval() {
    this.loyaltyPoint += this.loyaltyRedeemed;
    this.loyaltyRedeemed = 0;
    this.calculateSubTotal();
  }

  async onApplyCouponCode() {
    let exists = false;
    let individualUse = false;

    this.appliedCouponCodes.map(coupon => {
      if(coupon.couponCode.toUpperCase() == this.enteredCouponCode.toUpperCase())
        exists = true;
      if(coupon.individualUse)
        individualUse = true;
    });

    if(exists){
      this.couponError = "Coupon code already added!!";
      return;
    }

    if(individualUse){
      this.couponError = "Already added Coupon code can't be used in conjuction with other coupons.";
      return;
    }

    await this.couponService.validateAndGetCouponCode(this.enteredCouponCode,this.customerInfo ? this.customerInfo.userid : 0, false).subscribe({
      next: (response) => {
        if (response) {
          this.couponError = '';
          if(response.individualUse && this.appliedCouponCodes.length > 0){
            this.couponError = "Coupon can't be used in conjuction with other coupons.";
            return;
          }

          if (
              response.minSpend &&
              response.priceRangeApplyTo &&
              response.priceRangeApplyTo === 'ORDER_VALUE' &&
              this.localCart.total < response.minSpend
          ){
              this.alertService.alert(
                `Order total is less than minimum spend(£${response.minSpend})!`,
                'error'
              );
              return;
          }

          if (
              response.minSpend &&
              response.priceRangeApplyTo === 'NET_TOTAL' &&
              this.netTotal < response.minSpend
            ) {
              this.alertService.alert(
                `Cart net total is less than minimum spend(£${response.minSpend})!`,
                'error'
              );
              return;
          }
          
          if (
              response.maxSpend &&
              response.priceRangeApplyTo === 'ORDER_VALUE' &&
              this.localCart.total > response.maxSpend
            ) {
              this.alertService.alert(
                `Order total is greater than maximum spend(£${response.maxSpend})!`,
                'error'
              );
              return;
            }

            if (
              response.maxSpend &&
              response.priceRangeApplyTo === 'NET_TOTAL' &&
              this.netTotal > response.maxSpend
            ) {
              this.alertService.alert(
                `Cart net total is greater than maximum spend(£${response.maxSpend})!`,
                'error'
              );
              return;
            }

            const userType = this.customerInfo?.usertype || 'NONMEMBER';

            if(
              response.userRoles 
            ) {
              const allowedUsertypes = JSON.parse(response.userRoles);
              if (!allowedUsertypes.includes(userType)){
                this.alertService.alert('Coupon code not valid for current user type!', 'error');
                return;
              }
            }

          let amount = 0;
  
          this.localCart.items.map((item: any) => {
            let itemAmount = 0;
            if(item.categorySlug == 'free-samples'){}
            else if(response.excludeSales && item.onSale){}
            else {
              if(response.couponCategories.length > 0){
                const catExcluded = response.couponCategories.filter(c => c.include == false && (c.categoryId == item.categoryId || c.categoryId == item.parentId));
                if(catExcluded.length == 0){
                  const catIncluded = response.couponCategories.filter(c => c.include == true && (c.categoryId == item.categoryId || c.categoryId == item.parentId));
                  if(catIncluded.length > 0 || response.couponCategories.filter(c => c.include == true).length == 0){
                    itemAmount = item.quantity * item.unitPrice;
                  }
                  else 
                    itemAmount = 0;
                }
                else 
                  itemAmount = 0;
              }

              if(response.couponProducts.length > 0){
                const productExcluded = response.couponProducts.filter(c => c.include == false && c.productId == item.productId);
                if(productExcluded.length == 0){
                  const productIncluded = response.couponProducts.filter(c => c.include == true && c.productId == item.productId);
                  if(productIncluded.length > 0 || response.couponProducts.filter(c => c.include == true).length == 0){
                    itemAmount = item.quantity * item.unitPrice;
                  }
                  else 
                    itemAmount = 0;
                }
                else 
                  itemAmount = 0;
              }
               
              if(response.couponCategories.length == 0 && response.couponProducts.length == 0 )
                itemAmount = item.quantity * item.unitPrice;            
            }
            if(item.categorySlug !== 'free-samples')
              amount = amount + itemAmount;
          });

          if(amount == 0)
            this.couponError = "Coupon code not valid for cart items.";
          else if (response.giveAway && response.giveAway !== '') {
              const giveAwayData = JSON.parse(response.giveAway);
              const typeMatch = giveAwayData.type?.match(/^POPUP_(\d+|SINGLE)_PROD_SELECTION$/);
              if (typeMatch) {
                giveAwayData.maxSelections = typeMatch[1] === 'SINGLE' ? 1 : parseInt(typeMatch[1], 10);
                this.showGiveAwayProductSelection(giveAwayData, response, amount);
              }
          }
          else{
            this.appliedCouponCodes.push({...response,amount});
            this.enteredCouponCode = '';
            this.couponError = undefined;
            this.updateDiscountsAutomated();
          }
        } else {
          this.couponError = 'Invalid coupon code!';
        }
      },
      error: (error) => {
        this.couponError = error.error.message;
      },
    });

   
  }

  showGiveAwayProductSelection(giveAwayData: any, response: any, amount:number) {
     // const popupWidth = this.screenWidth < 768 ? '95%' : '80%';
      const dialogRef = this.dialog.open(GiveAwayProductSelectionComponent, {
        data: giveAwayData,
        width: "800px",
        maxWidth: "95vw",
      });
      dialogRef.afterClosed().subscribe((cartItems) => {
        if (!cartItems || (Array.isArray(cartItems) && cartItems.length === 0)) return;
        this.appliedCouponCodes.push({ ...response, amount });
        this.localCart.appliedCouponCodes = this.appliedCouponCodes;
        const items = Array.isArray(cartItems) ? cartItems : [cartItems];
        items.forEach((item: any) => this.localCart.items.push(item));
        this.cartService.setCart(this.localCart);
        this.enteredCouponCode = '';
        this.alertService.alert('Coupon code applied successfully!', 'success');
        this.updateDiscountsAutomated();
      });
  }

  handleGiveAwayCouponCodes(item: any) {
    if(item.giveAway && item.giveAway !== '') {
      const giveAwayData = JSON.parse(item.giveAway);
      const isGiveAwayType = /^POPUP_(\d+|SINGLE)_PROD_SELECTION$/.test(giveAwayData.type);
      if (isGiveAwayType) {
        const matchingIndexes = this.localCart.items
          .map((cartItem:any, index:number) => {
            const match = giveAwayData.data.products.some((g:any) => g.variantSku === cartItem.sku && cartItem.unitPrice == 0);
            return match ? index : -1;
          })
          .filter((index:any) => index !== -1);
        if (matchingIndexes && matchingIndexes.length > 0) {
          matchingIndexes.slice().reverse().forEach((index:number) => {
            this.localCart.items.splice(index, 1);
          });
        }
      }
    }
  }

  onRemoveCouponCode(item: any, index: number) {
    this.appliedCouponCodes.splice(index, 1);
    this.updateDiscountsAutomated();
    this.handleGiveAwayCouponCodes(item);
  }

  onCreateNewAddress(editingAddress?:any) {
    let modelConfig: any = {
      width: '75%',
      minHeight: '500px',
      data: {customerId: this.selectedCustomer.userid, isEdit: false},
    };
     if(editingAddress) {
      editingAddress.customerId = this.selectedCustomer? this.selectedCustomer.userid : editingAddress.userId;
      editingAddress.isEdit = true;
      modelConfig.data = editingAddress;
     }
    const dialogRef = this.dialog.open(CreateAddressModalComponent, modelConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status) {
        const alertMsg = editingAddress? 'Address updated!' : 'Adddress created!';
        this.alertService.alert(alertMsg, 'success');
        this.getCustomerAddresses(this.selectedCustomer.userid);
      }
    });
  }

  private resetAddresses() {
    this.defaultBillingAddress = undefined;
    this.defaultShippingAddress = undefined;
    this.billingAddresses = [];
    this.shippingAddresses = [];
    this.sameAddress = true;
    this.postCode = '';
  }



  private getAllProducts() {
    this.productService.getSalesProductSuggestions().subscribe({
      next: (response) => {
        this.productSuggestionList = response ?? [];
      },
      error: (error: { error: { message: any } }) =>
        this.alertService.alert(error.error.message, 'error'),
    });
  }

  private async getSelectedProduct(productSlug: string) {
    await this.productService.getProductBySlug(productSlug).subscribe({
      next: async (response) => {
        this.progress = false;
        this.editingProduct = response;
        this.galleryImage = null;
        this.clearCoverage();
        const loadedId = Number(this.editingProduct?.product?.productId);
        // Started at selection time; only needed here for accessories (which open by slug).
        if (loadedId && this.infoProductId !== loadedId) this.loadProductInfo(loadedId);
        this.refreshRecommendations();
        if (this.editingProduct) {
          this.editingProduct.variants = this.editingProduct.variants.filter((v: any) => v.trackQty == true);
          this.editingProduct.variants = this.editingProduct.variants.map(
            (variant: any) => {
              return { ...variant, quantity: 0, format: this.getFormat(variant),slabType: variant.sku.includes('SLAB') ? 'SLAB' :  variant.sku.includes('CRATE') ? 'CRATE' : '' };
            }
          );
          if (this.editingProduct.product.productTemplateId === 2) this.setSlabsCrates(this.editingProduct.variants);
        }
      },
      error: (error) => {
        this.alertService.alert(error.error.message, 'error');
      },
    });
  }
  private getFormat(variant: any) {
    let allAttrs = '';
    let attributes = this.editingProduct.attributes.filter(
      (att: any) => att.variants == true
    );
    for(let vd of variant.variantdetails){
      for(let attr  of attributes){
        let attrValue =  attr.attributevalues.find(
          (attv: any) => attv.id  == vd.productAttributeValueId
        );
        if(attrValue){
          allAttrs = allAttrs + (allAttrs == '' ? '' : ',')  + attrValue.productattributeName?.attributeValueSlug
        }
      }
    }
    return allAttrs;

  }


  private setSlabsCrates(variants: any) {
    this.slabsCrates = {
      slab: variants.find( (variant: any) => variant.format === 'Slab' ),
      crate: variants.find( (variant: any) => variant.format === 'Crate' ),
    }
  }

  // Customer picker searches the server as you type (see
  // CustomerTypeheadComponent.searchFn) - no full customer list is loaded.
  searchCustomers = (keyword: string) => this.userService.searchCustomers(keyword);

  private async getCustomerInfo(email: string) {
    await this.userService
      .getCustomerInfo(
        email
      )
      .subscribe({
        next: (response) => {
          this.customerInfo = response;
        this.refreshCouponSuggestions();
          this.loyaltyPoint = this.customerInfo.userpoints;
          this.calculateShippingCost();
        },
        error: (error) => this.alertService.alert(error.error.message, 'error'),
      });
  }

  private async getCustomerAddresses(customerId: number) {
    await this.userService
      .getCustomerAddresses(
        customerId
      )
      .subscribe({
        next: (response) => {
          this.progress = false;
          this.shippingAddresses = [];
           this.billingAddresses = [];
          response.forEach((addrs: any) => {
            if (addrs.addressType === 'BILLING') {
              this.billingAddresses.push(addrs);
              if(addrs.isDefault) this.defaultBillingAddress = addrs;
            }
            if (addrs.addressType === 'SHIPPING') {
              this.shippingAddresses.push(addrs);
              if(addrs.isDefault) this.defaultShippingAddress = addrs;
            }
            this.postCode = '';
            if (this.defaultShippingAddress && !this.sameAddress) {
              this.postCode = this.defaultShippingAddress?.postCode;
            } else {
              this.postCode = this.defaultBillingAddress?.postCode;
            }
          });
          this.getCustomerInfo(this.selectedCustomer.useremail);
        },
        error: (error) => this.alertService.alert(error.error.message, 'error'),
      });
  }

  onSamaddressChange(){
    this.postCode = '';
    if (this.sameAddress && this.billingAddresses.length > 0 && this.defaultBillingAddress)
      this.postCode = this.defaultBillingAddress?.postCode;
    if (!this.sameAddress && this.shippingAddresses.length > 0 && this.defaultShippingAddress) 
      this.postCode = this.defaultShippingAddress?.postCode;
    this.calculateShippingCost();
  }

 
  calculateShippingCost() {
    this.refreshRecommendations(); // every basket change ends up here
    let totalQty = 0;
    let slabWeight = 0;
    let aggWeight = 0;
    let stoneCladdingQty = 0;
    this.localCart.items.map((item: any) => {
      if (isPavingProduct(item.categorySlug, item.sku)) {
        if (item.isFullCrate) totalQty += item.quantity;
        else {
          slabWeight += item.quantity * item.weight;
        }
      }
      if (item.categorySlug == 'aggregates') {
        aggWeight +=  item.quantity * item.weight;
      }
      if (isStoneCladdingProduct(item.categorySlug))
        stoneCladdingQty += stoneCladdingCartons(item);
    });

    totalQty += (Math.ceil(slabWeight / 1000) + Math.ceil(aggWeight / 1000)) + getStoneCladdingLoads(stoneCladdingQty);

    let shippingCost = -1;
    let pCode = '';
    if (this.postCode) this.postCode = this.postCode.toUpperCase();
    postcodes.map((postcode) => {
      postcode.code.forEach((code) => {
        if (code.includes('|')){
          let codeSplit = code.split('|');
          let codePrefix = codeSplit[0];
          let rangeArr = codeSplit[1].split('-');
          for(let i = Number(rangeArr[0]); i <= Number(rangeArr[1]); i++){
            let newCode = codePrefix + i.toString();
            if (this.postCode?.startsWith(newCode) && newCode.length > pCode.length ) {
              pCode = newCode;
              if(postcode.priceOnRequest)
                shippingCost = 0;
              else
                shippingCost = postcode.amount;
              this.zoneNumber = postcode.zone;
              this.priceOnRequest = postcode.priceOnRequest;
            }
          }
        }
        else{
          if (this.postCode?.startsWith(code) && code.length > pCode.length ) {
            pCode = code;
            if(postcode.priceOnRequest)
              shippingCost = 0;
            else
              shippingCost = postcode.amount;
            this.zoneNumber = postcode.zone;
            this.priceOnRequest = postcode.priceOnRequest;
          }
        }
      });
    });
  
    if (shippingCost == -1) {
      this.shipCost = 0;
      this.invalidPostcode = true;
      this.zoneNumber = '';
      //this.alertService.alert('Invalid Postcode!', 'error');
    } else {
      this.invalidPostcode = false;
      if (this.selectedDeliveryMethod !== 'COLLECTION')
        this.shipCost = totalQty * shippingCost;
    }

    if (totalQty > 0) {
      switch (this.selectedDeliveryMethod) {
        case 'EXPRESS':
          this.shipCost +=
            totalQty * (this.customerInfo ? this.customerInfo.expressDeliveryCost : 30);
          break;
        case 'NEXTDAY':
          this.shipCost +=
            totalQty * (this.customerInfo ? this.customerInfo.nextDayDeliveryCost : 50);
          break;
        case 'COLLECTION':
          this.shipCost = 0;
          break;
      }
    } else {
      this.shipCost = 0;
    }
    this.updateDiscountsAutomated();
  }

  async updateDiscountsAutomated() {
    this.redeemedDicounts = [];
    let freeSampleAmt = 0;
    let accessoryAmt = 0;
    let pavingAmt = 0;
    let pavingCollectionQty = 0;
    let accessoryDisc = 0;
    let pavingDisc = 0;
    let pavingCollectionDisc = 0;
    let pavingSplitQty = 0;
    let fencingQty = 0;
    let deckingQty = 0;

    let pavingFound = false;
    let deckingFound = false;
    let stoneCladdingQty = 0;
    this.handleCharge = 0;

    for(let i = 0; i < this.localCart.items.length; i++){
      const item = this.localCart.items[i];
      if (isPavingProduct(item.categorySlug, item.sku)) 
        pavingFound = true;
      if((item.categorySlug == 'composite-fencing' || item.categorySlug == 'composite-decking'
        || item.categorySlug == 'landscaping-and-outdoor')  && [405, 636].indexOf(item.productId) < 0) {
        deckingFound = true;
      }

      if (isStoneCladdingProduct(item.categorySlug))
        stoneCladdingQty += stoneCladdingCartons(item);

      if([497, 411].indexOf(item.productId) >= 0 && item.sku.indexOf('WITHOUT') >= 0){
          if(item.weight * item.quantity < 36)
            this.handleCharge += 50;
          else if(item.weight * item.quantity < 86)
            this.handleCharge += 85;
          else if(item.weight * item.quantity < 151)
            this.handleCharge += 120;      
          else if(item.weight * item.quantity > 150)
            this.handleCharge += 180;
      }

      if (this.customerInfo?.userrole == 'TRADER') {
        if (item.categorySlug == 'free-samples') {
          freeSampleAmt += item.unitPrice * item.quantity;
        } else {
          if (
            isPavingProduct(item.categorySlug, item.sku)||
            item.categorySlug == 'composite-fencing' ||
            item.categorySlug == 'composite-decking'
          ) {
            if (item.isFullCrate) {
              if (item.onSale == false && item.categorySlug !== 'composite-fencing' && item.categorySlug !== 'composite-decking')
                pavingAmt += item.unitPrice * item.quantity;
              if (this.selectedDeliveryMethod == 'COLLECTION' && isPavingProduct(item.categorySlug, item.sku))
                pavingCollectionQty += item.quantity;
              if (item.categorySlug == 'composite-fencing' && [497, 411, 405, 636].indexOf(item.productId) < 0)
                fencingQty += (item.quantity * item.weight) / 200;
              else if (item.categorySlug == 'composite-decking' && [497, 411, 405, 636].indexOf(item.productId) < 0)
                deckingQty += (item.quantity * item.weight) / 200;
            } else {
              if (item.onSale == false && item.categorySlug !== 'composite-fencing' && item.categorySlug !== 'composite-decking')
                pavingAmt += item.unitPrice * item.quantity;
              pavingSplitQty += (item.quantity * item.weight) / 1000;
            }
          }
        }
      } else {
        if (item.categorySlug == 'free-samples') {
          if(this.customerMode == 'GUEST'){
            try {
              const response: any = await firstValueFrom(this.orderService.verifySample(this.defaultBillingAddress.email,this.defaultBillingAddress.phoneNo,this.defaultBillingAddress.postCode));
              if (response && response.sample === true) {
                if (item.unitPrice > freeSampleAmt) freeSampleAmt = Number(item.unitPrice);
              }
            } catch (error: any) {
              this.alertService.alert(error.error?.message ?? 'Error verifying sample', 'error');
            }
          }
          else if (this.customerInfo?.freeSample) {
            if (item.unitPrice > freeSampleAmt)
              freeSampleAmt = Number(item.unitPrice);
          }

        } else if (
          isPavingProduct(item.categorySlug, item.sku)||
          item.categorySlug == 'composite-fencing' ||
          item.categorySlug == 'composite-decking'
        ) {
          
          if (item.isFullCrate) {
            if (this.selectedDeliveryMethod == 'COLLECTION' && isPavingProduct(item.categorySlug, item.sku))
              pavingCollectionQty += item.quantity;
            if (item.categorySlug == 'composite-fencing' && [497, 411, 405, 636].indexOf(item.productId) < 0)
              fencingQty += (item.quantity * item.weight) / 200;
            else if (item.categorySlug == 'composite-decking' && [497, 411, 405, 636].indexOf(item.productId) < 0)
              deckingQty += (item.quantity * item.weight) / 200;
          } else {
            pavingSplitQty += (item.quantity * item.weight) / 1000;
          }
        }
      }
    };

    this.deliveryType = '';
    if(this.selectedDeliveryMethod !== 'COLLECTION'){
      if(pavingFound || deckingFound || stoneCladdingQty > 0){
        if(pavingFound || stoneCladdingQty > 0){
          if(this.zoneNumber == '0')
            if(deckingFound)
              this.deliveryType = 'Kerbside Delivery' ;
            else
              this.deliveryType = 'Kerbside Delivery - FREE' ;
          else if(this.zoneNumber == '1')
            this.deliveryType = 'Price On Request' ;
          else
            this.deliveryType = 'Kerbside Delivery - Zone ' + this.zoneNumber + ' Surcharge';
        }

        if(deckingFound && this.zoneNumber !== '1'){
          if(this.deliveryType == '')
            this.deliveryType = '2 Man Delivery';
          else
            this.deliveryType = this.deliveryType + ' - 2 Man Delivery';
        }
      }
      else
        this.deliveryType = 'FREE DELIVERY' ;
    }
    if (
      accessoryAmt > 0 ||
      pavingAmt > 0 ||
      pavingCollectionQty > 0 ||
      freeSampleAmt > 0
    ) {
      pavingCollectionDisc =
        pavingCollectionQty *
        (this.customerInfo ? this.customerInfo.pavingCollectionDisc : 35);
      pavingDisc = (pavingAmt * this.customerInfo?.pavingDiscPerc) / 100;
      accessoryDisc = (accessoryAmt * this.customerInfo?.accessoryDiscPerc) / 100;

      if (freeSampleAmt > 0) {
        this.redeemedDicounts.push({
          code: 'free-samples',
          title: 'Free Sample Discount',
          discountedAmount: freeSampleAmt,
        });
      }

      if (accessoryDisc > 0 && !this.isTradeDiscountExludeCouponsAvailable()) {
        this.redeemedDicounts.push({
          code: 'accessories',
          title: 'Accessory Discount',
          discountedAmount: accessoryDisc,
        });
      }

      if (pavingDisc > 0 && !this.isTradeDiscountExludeCouponsAvailable()) {
        this.redeemedDicounts.push({
          code: 'trade',
          title: 'Trade Discount',
          discountedAmount: pavingDisc,
        });
      }

      if (pavingCollectionDisc > 0) {
        this.redeemedDicounts.push({
          code: 'collection',
          title: 'Collection Order Discount',
          discountedAmount: pavingCollectionDisc,
        });
      }
    } else {
      pavingCollectionDisc = 0;
      pavingDisc = 0;
      accessoryDisc = 0;
      this.redeemedDicounts = [];
    }

    if (pavingSplitQty > 0) {
      if (this.selectedDeliveryMethod == 'COLLECTION')
        this.handleCharge +=
          Math.ceil(pavingSplitQty) *
          (this.customerInfo ? this.customerInfo.handleFeeCollection : 45);
      else
        this.handleCharge +=
        Math.ceil(pavingSplitQty) *
          (this.customerInfo ? this.customerInfo.handleFeeDelivery : 85);
    } 

    if (fencingQty > 0) {
      if (this.selectedDeliveryMethod == 'COLLECTION')
        this.handleCharge +=
          Math.ceil(fencingQty) *
          (this.customerInfo ? this.customerInfo.handleFeeCollectionFencing : 65);
      else
        this.handleCharge +=
        Math.ceil(fencingQty) *
          (this.customerInfo ? this.customerInfo.handleFeeDeliveryFencing : 130);
    }

    if (deckingQty > 0) {
      if (this.selectedDeliveryMethod == 'COLLECTION')
        this.handleCharge +=
          Math.ceil(deckingQty) *
          (this.customerInfo ? this.customerInfo.handleFeeCollectionFencing : 65);
      else
        this.handleCharge +=
        Math.ceil(deckingQty) *
          (this.customerInfo ? this.customerInfo.handleFeeDeliveryFencing : 130);
    }

    if (stoneCladdingQty > 0)
      this.handleCharge += getStoneCladdingHandlingFee(stoneCladdingQty);

    this.updateDiscountsOnCoupons();
    this.calculateSubTotal();
  }

  private updateDiscountsOnCoupons() {
    if (this.appliedCouponCodes) {
      this.appliedCouponCodes.forEach((ccode) => {
        let discountAmount = ccode.couponPerc ? ((ccode.amount * ccode.couponValue) / 100) : Number(ccode.couponValue);
        this.redeemedDicounts.push({
          code: ccode.couponCode,
          title:
            "Coupon code '" +
            ccode.couponCode +
            "' applied for '" +
            ccode.couponValue +
            (ccode.couponPerc ? "%'" : "£'") + " discount",
          discountedAmount: discountAmount,
        });
      });
    }
  }

  private isTradeDiscountExludeCouponsAvailable() {
    let available = false;
    if (this.appliedCouponCodes) {
      this.appliedCouponCodes.forEach((ccode) => {
        if(ccode.invalidateTradeDiscounts) available = true;
      });
    }
    return available;
  }
  
  private calculateSubTotal() {
    let totalDiscountedAmount = 0;
    if (this.redeemedDicounts.length > 0) {
      this.redeemedDicounts.forEach((disc: any) => {
        totalDiscountedAmount += disc.discountedAmount;
      });
    }
    totalDiscountedAmount += this.loyaltyRedeemed;
    this.subTotal = this.localCart.total;
    this.vatAmount = this.subTotal / 6;
    this.netTotal = this.subTotal - totalDiscountedAmount + this.shipCost + this.handleCharge;
    this.refreshCouponSuggestions();
  }
  
  // Mirrors the storefront's cart-removal guard: can't remove a product
  // while an accessory elsewhere in the basket ("With Paving"/"With
  // Fencing"/"With Decking"/"With Panels") still depends on it being there.
  private checkCanRemoveItem(item: any, cartItems: any[], currentTotal: number): string | null {
    const itemPrice = item.unitPrice * item.quantity;
    if (this.isPavingProduct(item.categorySlug, item.sku)) {
      const pavingAccCount = cartItems.filter((i: any) => i.name?.indexOf('With Paving') >= 0 && !i.isGiveAway).length;
      const pavingCount = cartItems.filter((i: any) => this.isPavingProduct(i.categorySlug, i.sku)).length;
      if (pavingAccCount > 0 && pavingCount == 1) {
        return "Please remove the paving acceessory 'With Paving' first!!";
      }
    } else if (item.categorySlug?.indexOf('fencing') >= 0 && item.name?.indexOf('Panel Kit') >= 0) {
      const fencingAccCount = cartItems.filter((i: any) => i.name?.indexOf('With Fencing') >= 0 && !i.isGiveAway).length;
      const fencingCount = cartItems.filter((i: any) => i.categorySlug?.indexOf('fencing') >= 0 && i.name?.indexOf('Panel Kit') >= 0).length;
      if (fencingAccCount > 0 && fencingCount == 1) {
        return "Please remove the fencing acceessory 'With Fencing' first!!";
      }
    } else if (item.categorySlug?.indexOf('decking') >= 0 && item.name?.indexOf('3D Embossed') >= 0) {
      const deckingAccCount = cartItems.filter((i: any) => i.name?.indexOf('With Decking') >= 0 && !i.isGiveAway).length;
      const deckingCount = cartItems.filter((i: any) => i.categorySlug?.indexOf('decking') >= 0 && i.name?.indexOf('End Cover') >= 0).length;
      if (deckingAccCount > 0 && deckingCount == 1) {
        return "Please remove the decking acceessory 'With Decking' first!!";
      }
    }

    const wallPanelAdhesCount = cartItems.filter((i: any) => i.name?.indexOf('With Panels') >= 0 && !i.isGiveAway).length;
    if (item.categorySlug !== 'wall-panel-adhesive-sealant' && wallPanelAdhesCount > 0 && currentTotal - itemPrice < 88) {
      return "Please remove the wall panel adhesive 'With Panels' first!!";
    }
    return null;
  }

  onCartItemRemoval(i: number) {
    const item = this.localCart.items[i];
    const removalError = this.checkCanRemoveItem(item, this.localCart.items, this.localCart.total);
    if (removalError) {
      this.alertService.alert(removalError, 'error');
      return;
    }
    const itemPrice = item.unitPrice * item.quantity;
    this.localCart.total -= itemPrice;
    this.localCart.totalFormatted = this.localCart.total.toFixed(2);
    this.localCart.items.splice(i, 1);
    this.localCart.appliedCouponCodes = [];
    this.removeGiveAwayItms();
    this.cartService.setCart(this.localCart);
    this.appliedCouponCodes = [];
    this.calculateShippingCost();
  }

  removeGiveAwayItms(){
    let items = this.localCart.items.filter((item: any) => item.unitPrice > 0);
    this.localCart.items = items;
  }

  private async saveOrder() {
    if (!this.orderSubmitted) {
      this.orderSubmitted = true;
      let order: any;
      let totalDiscountedAmount = 0;
      this.progress = true;
      let freeSample = this.customerInfo?.freeSample;
      let deckingFound = false;
      let freeSampleCount = 0;

      this.localCart.items.map((item: any) => {
        if ((this.selectedDeliveryMethod == 'NEXTDAY' || this.selectedDeliveryMethod == 'EXPRESS') && (item.categorySlug == 'composite-fencing' || item.categorySlug == 'composite-decking'
          || item.categorySlug == 'landscaping-and-outdoor'))
          deckingFound = true;
        if (item.categorySlug == 'free-samples') {
          freeSampleCount += 1;
        }
      });

      if ((this.selectedDeliveryMethod == 'NEXTDAY' || this.selectedDeliveryMethod == 'EXPRESS') && freeSampleCount == this.localCart.items.length) {
        this.alertService.alert('Selected Delivery method is not available for free sample products', 'error');
        this.progress = false;
        this.orderSubmitted = false;
        return;
      }

      if (deckingFound) {
        this.alertService.alert('Selected Delivery method is not available for decking/fencing/furniture products', 'error');
        this.progress = false;
        this.orderSubmitted = false;
        return;
      }

      if (this.redeemedDicounts.length > 0) {
        this.redeemedDicounts.forEach((disc: any) => {
          if (disc.code == 'free-samples') freeSample = false;
          totalDiscountedAmount += disc.discountedAmount;
        });
      }
      totalDiscountedAmount += this.loyaltyRedeemed;
      let orderItems = this.localCart.items.map((item: any) => {
        return {
          productId: item.productId,
          variantId: item.variantId,
          unitPrice: Number(item.unitPrice),
          quantity: item.quantity,
          subTotal: item.quantity * item.unitPrice,
          productSku: item.sku,
          productName: item.name,
          productdterms: item.deliveryTermSlug ? `Estimated delivery is ${item.deliveryTermSlug} working days` : '',
          productFormat: item.productFormat,
          weight: item.weight,
          onSale: item.onSale,
          categorySlug: item.categorySlug,
          categoryId: item.categoryId,
          parentId: item.parentId,
        };
      });

      let minValue = 0;
      let maxValue = 0;
      let deliveryTerms = '';
      let hasInvalidDeliveryTerm = false;
      let oncallPresent = false;

      try {
        this.localCart.items.map((item: any) => {
          if (!item.deliveryTermSlug) {
            hasInvalidDeliveryTerm = true;
            return;
          }
          if (item.deliveryTermSlug === 'call') {
            oncallPresent = true;
            return;
          }
          let arr = item.deliveryTermSlug.split('-');
          const lo = Number(arr[0]);
          const hi = Number(arr[1]);
          // A malformed/non-numeric deliveryTermSlug produces NaN here.
          // Comparing NaN against minValue/maxValue is always false, so it
          // would otherwise be silently skipped rather than corrupting the
          // total - masking a broken item behind a confident-looking range
          // from the other, valid items.
          if (isNaN(lo) || isNaN(hi)) {
            hasInvalidDeliveryTerm = true;
            return;
          }
          if (lo < minValue || minValue == 0)
            minValue = lo;
          if (hi > maxValue || maxValue == 0)
            maxValue = hi;
        });

        deliveryTerms = `Estimated delivery is ${minValue} to ${maxValue} working days`
      }
      catch (e) { }

      if ((this.selectedDeliveryMethod === 'EXPRESS' || this.selectedDeliveryMethod === 'NEXTDAY' || this.selectedDeliveryMethod === 'COLLECTION') && maxValue > 5) {
        this.alertService.alert('Selected Delivery method is not available for products with delivery terms > 5days ', 'error');
        this.progress = false;
        this.orderSubmitted = false;
        return;
      }

      if (oncallPresent) {
        this.alertService.alert('One of the items in this order is "on call" delivery - please contact the customer to arrange this before placing the order.', 'error');
        this.progress = false;
        this.orderSubmitted = false;
        return;
      }

      // A product's delivery term couldn't be parsed into a valid day range
      // (missing, non-numeric, or malformed deliveryTermSlug) - don't let an
      // order go out with a meaningless "NaN to NaN"/"0 to 0" estimate, and
      // don't let a broken item hide behind a confident-looking range from
      // the other, valid items in the cart. Doesn't apply to Express/
      // Next-day/Collection, which override this text below regardless of
      // minValue/maxValue.
      if (
        this.selectedDeliveryMethod !== 'EXPRESS' &&
        this.selectedDeliveryMethod !== 'NEXTDAY' &&
        this.selectedDeliveryMethod !== 'COLLECTION' &&
        (hasInvalidDeliveryTerm || isNaN(minValue) || isNaN(maxValue) || minValue <= 0 || maxValue <= 0)
      ) {
        this.alertService.alert("One of the items in this order is missing a valid delivery estimate. Please check the product's delivery term before placing this order.", 'error');
        this.progress = false;
        this.orderSubmitted = false;
        return;
      }

      if (this.selectedDeliveryMethod === 'EXPRESS')
        deliveryTerms = 'Estimated delivery is 2 to 3 working days';
      else if (this.selectedDeliveryMethod === 'NEXTDAY')
        deliveryTerms = 'Estimated delivery is the next working day for orders received before 11 AM';
      else if (this.selectedDeliveryMethod === 'COLLECTION')
        deliveryTerms = '';

      if (this.defaultBillingAddress == null) {
        this.alertService.alert('Billing address is required', 'error');
        this.progress = false;
        return;
      }
      this.defaultBillingAddress.addressType = 'BILLING';
      if (this.defaultShippingAddress) this.defaultShippingAddress.addressType = 'SHIPPING';


      let orderData: any = {
        customerId: this.customerInfo && this.customerMode == 'CUSTOMER' ? this.selectedCustomer.userid : 0,
        orderAmount: this.localCart.total,
        discAmount: totalDiscountedAmount,
        shipCost: this.shipCost,
        handleCharge: this.handleCharge,
        netAmount: this.netTotal,
        userpoints: this.loyaltyPoint,
        orderItems: orderItems,
        billingAddressId: this.customerInfo && this.customerMode == 'CUSTOMER' ? this.defaultBillingAddress.id : 0,
        shippingAddressId:
          this.customerInfo && this.customerMode == 'CUSTOMER' && !this.sameAddress
            ? this.defaultShippingAddress.id
            : 0,
        freeSample: freeSample,
        paymentMethod: this.netTotal == 0 ?  'NO-PAYMENT' : this.selectedPaymentOption,
        customerBAddress:
          this.customerMode == 'GUEST' && this.defaultBillingAddress
            ? this.defaultBillingAddress
            : null,
        customerSAddress:
          this.customerMode == 'GUEST' && !this.sameAddress && this.defaultShippingAddress
            ? this.defaultShippingAddress
            : null,
        deliveryTerms: deliveryTerms,
        deliveryMethod: this.selectedDeliveryMethod,
        customerMode: this.customerMode,
        discountCoupons: this.appliedCouponCodes,
        vatNumber: this.userVatNu,
        deliveryType: this.deliveryType,
        orderNotes: this.orderNotes,
      };

      if (this.selectedPaymentOption === 'PAYPAL' && this.paypalPaymentComplete && this.paypalResponse && this.paypalResponse.data && this.paypalResponse.data.orderID) {
        orderData.paypalOrderId = this.paypalResponse.data.orderID;
      }

      await this.orderService.createOrder(orderData).subscribe({
        next: (response) => {
          order = response;
          this.progress = false;
          if (order && order?.orderId) {
            this.cartService.resetCart();
            this.onReset();
            this.alertService.alert('Order Saved successfully.', 'success');
            this.orderService.setEditingOrderID(order.orderId);
            switch (order.paymentMethod) {
              case 'BANK_TRANSFER':
              case 'INVOICE':
              case 'NO-PAYMENT':
              case 'PAYPAL':
                this.router.navigate(['sales/edit']);
                break;
              case 'PAYLATR':
                window.location.replace(response.sessionUrl);
                break;
              case 'SUMUP':
                window.location.replace(response.sessionUrl);
                break;
              case 'TEYA':
                window.location.replace(response.sessionUrl);
                break;
              case 'TRUST_PAYMENT':
                this.createTrustPaymentSession({
                  encryptedOrder: response.encryptedOrder,
                  amount: response.netAmount,
                  orderId: response.orderNo.toString(),
                  siteReference: response.siteReference,
                  backEndUrl: response.backEndUrl,
                  frontEndUrlBO: response.frontEndUrlBO,
                });
                break;
              case 'KLARNA':
                if (order.html_snippet) this.showKlarnaHTML(order.html_snippet)
                break;
            }
          } else this.alertService.alert('Error while creating Order!', 'error');
        },
        error: (error) => {
          this.progress = false;
          this.orderSubmitted = false;
          this.alertService.alert(error.error.message, 'error');
        },
      });
    }
  }

  async createTrustPaymentSession(params: any) {
    try {
      const url = `${params.frontEndUrlBO}/sales/edit`;
      const ackUrl = `${params.backEndUrl}/orders/update/trust`;
      //const ackUrl = `https://ee5e87d56a6b.ngrok-free.app/orders/update/trust`;

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = 'https://payments.securetrading.net/process/payments/details';
    
      const data: Record<string, any> = {
        sitereference: params.siteReference,
        stprofile: 'default',
        currencyiso3a: 'GBP',
        mainamount: params.amount.toFixed(2),
        orderreference: params.orderId,
        version: '2',
        successfulurlredirect: url,
        successfulurlnotification: ackUrl,
        stdefaultprofile: 'st_paymentcardonly'
      };
    
      for (const key in data) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
      }
    
      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      console.log(error)
    }
  }

  private showKlarnaHTML(html: string) {
    let modelConfig: any = {
      data: {
        html_snippet: html
      },
      width: '80%',
      minHeight: '500px',
    };
    const dialogRef = this.dialog.open(KlarnaModalComponent, modelConfig);
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }


}

interface CoverageSuggestion {
  key: 'VALUE' | 'EXCESS' | 'PACKS' | 'ALL';
  label: string;
  icon: string;
  lines: { variant: any; qty: number }[];
  coverage: number;
  extra: number;
  price: number;
  perM2: number;
  packs: number;
  short: boolean;
}

interface ProductInfo {
  highlights: string[];
  kits: { title: string; headers: string[]; rows: string[][] }[];
  notes: { title: string; html: string }[];
  accessorySlugs: string[];
  layingGuide: { text: string; href: string } | null;
}
